"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingPowerLimitCommandValidation = void 0;
class ChargerControlChargingPowerLimitCommandValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // If entity.p_lim_kw exists, validate that it has the correct type.
        if (entity.p_lim_kw != undefined) {
            if (typeof entity.p_lim_kw !== "number")
                return false;
        }
        // If entity.p_safety_limit_kw exists, validate that it has the correct type.
        if (entity.p_safety_limit_kw != undefined) {
            if (typeof entity.p_safety_limit_kw !== "number")
                return false;
        }
        return true;
    }
}
exports.ChargerControlChargingPowerLimitCommandValidation = ChargerControlChargingPowerLimitCommandValidation;
